document.addEventListener("DOMContentLoaded", function () {
  // すべての .movie__modal-youtube の要素を取得
  document.querySelectorAll(".js-youtube").forEach((modal) => {
    const iframe = modal.querySelector("iframe");

    if (iframe) {
      // iframe の src から YouTube の動画 ID を取得
      const url = iframe.src;
      const match = url.match(/[\/?=]([a-zA-Z0-9_-]{11})[&\?]?/);

      if (match) {
        const videoId = match[1];

        // 親の .movie__modal の data-movie-modal を取得
        const movieIndex = modal.closest(".movie__modal").getAttribute("data-movie-modal");

        // 該当する data-movie の .js-youtube-thumbnail を探す
        const thumbnailContainer = document.querySelector(`.movie__list-item[data-movie="${movieIndex}"] .js-youtube-thumbnail`);

        if (thumbnailContainer) {
          // サムネイル画像を設定
          const thumbnailImg = document.createElement("img");
          thumbnailImg.src = `https://img.youtube.com/vi/${videoId}/sddefault.jpg`;
          thumbnailImg.alt = "YouTube サムネイル";
          thumbnailContainer.appendChild(thumbnailImg);
        }
      }
    }
  });
});
